"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var shared_module_1 = require("../shared.module");
var common_1 = require("@angular/common");
/**
 * Use this namespace for importing Authentication's service HttpAuthenticationService
 * (there is typo in idm-authentication-client-js package http authentication service name
 * HttpAuthorizationService must be HttpAuthenticationService)
 */
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var idm_page_service_client_js_1 = require("@synisys/idm-page-service-client-js");
var navigation_message_service_1 = require("../../services/navigation-message-service");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
/**
 * General module for providing HTTP implementations of services which provide some logic for different pages
 */
var OnlineProvidersModule = /** @class */ (function () {
    function OnlineProvidersModule() {
    }
    OnlineProvidersModule = __decorate([
        core_1.NgModule({
            imports: [shared_module_1.SharedModule, common_1.CommonModule, idm_kb_service_client_js_1.KbServiceModule],
            providers: [
                navigation_message_service_1.NavigationMessageService,
                { provide: idm_page_service_client_js_1.PageNavigationService, useClass: idm_page_service_client_js_1.HttpPageNavigationService },
                { provide: idm_classifier_service_client_js_1.ClassifierService, useClass: idm_classifier_service_client_js_1.ClassifierHttpService },
                { provide: idm_validation_calculation_service_client_js_1.ValidationService, useClass: idm_validation_calculation_service_client_js_1.ValidationHttpService },
                { provide: idm_document_service_client_js_1.DocumentService, useClass: idm_document_service_client_js_1.HttpDocumentService }
            ]
        }),
        __metadata("design:paramtypes", [])
    ], OnlineProvidersModule);
    return OnlineProvidersModule;
}());
exports.OnlineProvidersModule = OnlineProvidersModule;
//# sourceMappingURL=online-providers.module.js.map